/* tslint:disable */
/* eslint-disable */
/**
 * Ion.Reporting.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  PermissionsPermissionType,
  PermissionsPermissionTypeFromJSON,
  PermissionsPermissionTypeFromJSONTyped,
  PermissionsPermissionTypeToJSON,
} from "./";

/**
 *
 * @export
 * @interface UsersPermissionChangeCommand
 */
export interface UsersPermissionChangeCommand {
  /**
   * ID of user to grant permissions to
   * @type {string}
   * @memberof UsersPermissionChangeCommand
   */
  userId?: string | null;
  /**
   * ID of developer to grant permissions to
   * @type {string}
   * @memberof UsersPermissionChangeCommand
   */
  developerId?: string | null;
  /**
   * Optional ID of property to grant permissions to.  Leave blank when granting developer-level access
   * @type {string}
   * @memberof UsersPermissionChangeCommand
   */
  propertyId?: string | null;
  /**
   *
   * @type {PermissionsPermissionType}
   * @memberof UsersPermissionChangeCommand
   */
  type?: PermissionsPermissionType;
}

export function UsersPermissionChangeCommandFromJSON(json: any): UsersPermissionChangeCommand {
  return UsersPermissionChangeCommandFromJSONTyped(json, false);
}

export function UsersPermissionChangeCommandFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UsersPermissionChangeCommand {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    userId: !exists(json, "userId") ? undefined : json["userId"],
    developerId: !exists(json, "developerId") ? undefined : json["developerId"],
    propertyId: !exists(json, "propertyId") ? undefined : json["propertyId"],
    type: !exists(json, "type") ? undefined : PermissionsPermissionTypeFromJSON(json["type"]),
  };
}

export function UsersPermissionChangeCommandToJSON(value?: UsersPermissionChangeCommand | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    userId: value.userId,
    developerId: value.developerId,
    propertyId: value.propertyId,
    type: PermissionsPermissionTypeToJSON(value.type),
  };
}
